/**
 *
 * @param plan
 * @returns {*}
 */
export function getPlanSubscriptionName(plan) {
  return plan ? plan.name : null;
}
